import $ from "jquery";
import validation from "../../abstracts/validation";

const utilsSwiper = () => {
  const init = () => {
    execute();
  };

  const execute = () => {
    const el = {
      main: ".js-form",
    };

    if ($(el.main).length === 0) return;

    const { onInput, onSubmit } = validation();

    $(document).on("submit", el.main, function (e) {
      onSubmit(e, $(this));
    });

    onInput(el.main);
  };

  init();
};

try {
  utilsSwiper();
} catch (error) {
  console.error("utilsSwiper", error);
}
